/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleUserRequest } from '../models/SimpleUserRequest';
import { HttpFile } from '../http/http';

export class ChatUserRequest {
    'user': SimpleUserRequest;
    'isOnline'?: boolean;
    'seenLatestMessage'?: boolean;
    'room': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "user",
            "baseName": "user",
            "type": "SimpleUserRequest",
            "format": ""
        },
        {
            "name": "isOnline",
            "baseName": "isOnline",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "seenLatestMessage",
            "baseName": "seenLatestMessage",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "room",
            "baseName": "room",
            "type": "number",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ChatUserRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

